import { render, staticRenderFns } from "./AdminConsolePage.vue?vue&type=template&id=5e58525e&scoped=true"
import script from "./AdminConsolePage.vue?vue&type=script&lang=js"
export * from "./AdminConsolePage.vue?vue&type=script&lang=js"
import style0 from "./AdminConsolePage.vue?vue&type=style&index=0&id=5e58525e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e58525e",
  null
  
)

export default component.exports